import { useTranslation } from 'react-i18next'

import { useFetchPersonalOffers } from '@entities/Loyalty'

import { useAuth } from '@features/auth'
import { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { PersonalOffersSlider } from '@widgets/personal-offers-slider'

export default function PersonalOffersBlock ({
  shopId
}: BlockProps) {
  const { t } = useTranslation()
  const { isAuthorized, requireRegistration } = useAuth()
  
  
  const { 
    personalOffers, 
    loading
  } = useFetchPersonalOffers(shopId)

  // Не показываем блок для неавторизованных пользователей
  if (!isAuthorized || requireRegistration) {
    return null
  }

  if (!personalOffers || personalOffers.personalOffers.length === 0) {
    return null
  }

  return (
    <div className={styles.root__personalOffers}>
      <h3 className={styles.personalOffers__title}>
        {t('personalOffers')}
      </h3>
      <PersonalOffersSlider 
        offers={personalOffers.personalOffers.flatMap(p => p.items)} 
        loading={loading} 
      />
    </div>
  )
}